import React from "react";
import styles from "./AppPagination.module.scss";
import {Pagination} from "react-bootstrap";
import {useSearchParams} from "react-router";

export const AppPagination = ({totalElements, totalPages, page, itemName}) => {
  const [_searchParams, setSearchParams] = useSearchParams();

  const goToPage = page => () => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);

      if (page <= 0) {
        next.delete("page");
      } else if (page > totalPages - 1) {
        next.set("page", totalPages - 1);
      } else {
        next.set("page", page);
      }

      return next;
    });
  };

  return <div className={styles.pagination}>
    <div className={styles.itemsCount}>{totalElements} {itemName}{totalElements > 1 ? "s" : ""}</div>

    <Pagination>
      <Pagination.First onClick={goToPage(0)} disabled={page === 0}/>
      <Pagination.Prev onClick={goToPage(page - 1)} disabled={page === 0}/>
      <Pagination.Item disabled>{page + 1} / {totalPages}</Pagination.Item>
      <Pagination.Next onClick={goToPage(page + 1)} disabled={page === totalPages - 1}/>
      <Pagination.Last onClick={goToPage(totalPages - 1)} disabled={page === totalPages - 1}/>
    </Pagination>
  </div>;
};
